import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import CreateUserForm from "../Forms/CreateUserForm";

interface CreateUserModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
}

const CreateUserModal: FC<CreateUserModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
}) => {
  const handleSubmit = async () => {
    onSubmit?.();
    handleClose();
  };
  const handleClose = () => {
    onClose();
  };
  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <CreateUserForm
        width={550}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Modal>
  );
};

export default CreateUserModal;
